import { render, staticRenderFns } from "./SortSelect.vue?vue&type=template&id=ec577d5c&scoped=true"
import script from "./SortSelect.ts?vue&type=script&lang=ts&external"
export * from "./SortSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./SortSelect.vue?vue&type=style&index=0&id=ec577d5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec577d5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec577d5c')) {
      api.createRecord('ec577d5c', component.options)
    } else {
      api.reload('ec577d5c', component.options)
    }
    module.hot.accept("./SortSelect.vue?vue&type=template&id=ec577d5c&scoped=true", function () {
      api.rerender('ec577d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/AtrContracts/components/SortSelect/SortSelect.vue"
export default component.exports